var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowPartner(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.28284 3.28284C8.43905 3.12663 8.43905 2.87337 8.28284 2.71716L5.73726 0.171573C5.58105 0.0153632 5.32778 0.0153632 5.17157 0.171573C5.01536 0.327783 5.01536 0.581048 5.17157 0.737258L7.43431 3L5.17157 5.26274C5.01536 5.41895 5.01536 5.67222 5.17157 5.82843C5.32778 5.98464 5.58105 5.98464 5.73726 5.82843L8.28284 3.28284ZM0 3.4H8V2.6H0V3.4Z",
    fill: "#5555FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowPartner);
export default __webpack_public_path__ + "static/media/RightArrowPartner.e54d31f724decb4f8cbe8123a80c0e90.svg";
export { ForwardRef as ReactComponent };